// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"dbfa7cef","198":"599219c9","215":"38c792f2","498":"4d07eba2","703":"9d61557f","830":"ff0ba838"}[chunkId] + ".chunk.js";
};